<template>
  <div class="container">
      <div class="content">
        <!-- {{ detail }} -->
        <detail ref="detail" @detail="setDetail" @applay="showApply" ></detail>
        <div class="footer" :class="[isCollapsed?'footer-collapsed':'']">
          <!-- status 1:正在处理 2:撤销 3:驳回 4:已结束 -->
           <!-- processFinished  是否已完成的状态标志-->
          <div class="footer-btn" v-show="detail.status">
            <template v-if="buttonNavigation.previous || buttonNavigation.next">
              <el-button :disabled="!buttonNavigation.previous" @click="checkId('previous')">上一条</el-button>
              <el-button :disabled="!buttonNavigation.next"  @click="checkId('next')">下一条</el-button>
            </template>
            <el-button type="info" plain  @click="returnToApprovals()">返回</el-button>
            <el-button type="primary" v-if="!$root.desktopWorkbench && detail.businessName && detail.businessName !== 'noticeDetail'" plain  @click="lookAccount()">查看账号</el-button>
            <el-button type="primary" v-if="!$root.desktopWorkbench && detail.businessName === 'noticeDetail'" plain  @click="lookAnnouncement()">查看</el-button>
            <el-button type="change" v-if="detail.canApprove" @click="onChange"  :loading="btnChangeLoading">转交</el-button>
            <el-button type="primary" v-if="detail.canAddApprover" @click="onAddUser"  :loading="btnAddUserLoading">添加审批人</el-button>
            <el-button type="primary"  @click="onComment" :loading="btnCommentLoading">评论</el-button>
            <el-button type="primary"  v-if="detail.canApprove" @click="onApply" :loading="btnApplyLoading">审批</el-button>
            <el-button type="primary" @click="getPdf('export')" :loading="btnExport">导出</el-button>
            <el-button type="primary" @click="getPdf('print')" :loading="btnPrint" >打印</el-button>
            <!-- <el-button type="primary"   @click="submitForm" :loading="btnLoading">提交审批</el-button> -->
          </div>
      </div>
      </div>
    <!-- 浮层 评论-->
    <popComment ref="popComment" @ok="setComment"></popComment>
    <popApply ref="popApply" @ok="setApply"></popApply>
    <org-picker :title="pickerTitle" ref="orgPicker" @ok="selected" />
  </div>
</template>
<script>
import mixinsDetail from '@/pages/officeApproval/approvalList/mixins/detail.js'
import popApply from "@/pages/officeApproval/approvalList/components/popApply.vue";
import OrgPicker from "@/components/OrgPicker";
export default {
  name: 'manageApprovalDetail',
  mixins: [mixinsDetail],
  components: {
    popApply,OrgPicker
  },
  data() {
      return {
          btnApplyLoading: false,
          btnChangeLoading: false,
          btnAddUserLoading: false,
          pickerTitle:'',
          buttonNavigation:{
            previous:'',
            next:''
          }
      }
  },
  created() {
  },
  activated() { 
  },
  mounted() {

  },
  methods: {
    // 获取上线条数据
    getWorkflowNavigation(){
      const postData = {
        processInstanceId:this.$route.query.id
      }
      return this.$api.participatedNavigation(postData).then((res) => {
        console.log("res", res.data);
        if (res.code === 0) {
          let { previousProcessInstanceId:previous,nextProcessInstanceId:next} = res.data
          this.buttonNavigation = {
            previous,
            next
          }
        }
      }).finally(()=>{
        
      })
    },
    // 点击上下条后检查
    async checkId(type){
      await this.getWorkflowNavigation()
      console.log('更新：', this.buttonNavigation)
      if (type == 'previous' ) {
        if (!!this.buttonNavigation.previous) {
            this.toLink(this.buttonNavigation.previous)
        }else{
            this.$message.warning('上一条没有可以审批的详情')
        }
      }else if (type == 'next' ) {
        if (!!this.buttonNavigation.next) {
            this.toLink(this.buttonNavigation.next)
        }else{
            this.$message.warning('下一条没有可以审批的详情')
        }
      }
     
    },
    // 上下一条数据
    toLink(id){
      console.log('>>',id)
      if(!id) return
      this.$router.push({
        name:'approvalManageDetail',
        query: {
          id,
        }
      })
    },
    // 转交
    onChange(){
      this.pickerTitle = '转交'
      this.actionType = 'changeUser'
      let select = []
      this.$refs.orgPicker.show(select,'user', this.actionType)
    },
    onAddUser(){
      this.pickerTitle = '添加审批人'
      this.actionType = 'addUser'
      let select = []
      this.$refs.orgPicker.show(select,'user', this.actionType)
    },
    // 返回选中的人员
    selected(e){
      if(e && e.length===0) return false
      if(this.actionType==='changeUser'){
        // 转交
        this.setChangeUser(e)
        // console.log('转交',JSON.stringify(e))
      }else if(this.actionType==='addUser'){
        // 添加审批人
        this.setAddUser(e)
        // console.log('添加审批人',JSON.stringify(e))
      }
    },
    // 转交
    setChangeUser(item){
      this.btnChangeLoading = true
      // const userId = sessionStorage.getItem("user_id")
      const postData = {
        taskId:this.detail.currentTaskId,
        toUserId:item.id,
        // fromUserId:userId,
        comment:item.comment,
      }
      this.$api.workflowChangeTask(postData).then((res) => {
        if(res.code === 0){
          this.returnToApprovals()
        }
      }).finally(()=>{
        this.btnChangeLoading = false
      })
    },
    // 添加审批人
    setAddUser(item){
      this.btnAddUserLoading = true
      // const userId = sessionStorage.getItem("user_id")
      const postData = {
        taskId:this.detail.currentTaskId,
        assigneeId:item.id,
        signType:item.signType,
        // fromUserId:userId,
        comment:item.comment,
        approveComment:item.approveComment, // 审批通过备注, // 审批通过备注
      }
      // console.log('添加审批人',postData,JSON.stringify(item))
      // return false
      this.$api.workflowAddTask(postData).then((res) => {
        if(res.code === 0){
          this.returnToApprovals()
        }
      }).finally(()=>{
        this.btnAddUserLoading = false
      })
    },
    // 审批
    onApply(){
      if(!this.detail.currentTaskId){
          console.error('没有taskId,无权处理！')
          return false
      }
      // 可编辑权限，先校验
      if (this.detail.canEditForm) {
        this.$refs.detail.validate();
      }else{
        this.showApply()
      }
      
    },
    showApply(){
      // 备注是否必填
      let isRequired = this.detail.mustApproveRemark
      this.$refs.popApply.show(isRequired);
    },
    setApply(form){
      let APIURL
      if(form.type==='pass'){
        APIURL = 'workflowComplete'
      }else if(form.type==='reject'){
        APIURL = 'workflowReject'
      }
      const postData = {
        processInstanceId:this.$route.query.id,
        taskId:this.detail.currentTaskId,
        comments: form.comment,
      };
      // 可编辑权限,才提交数据
      if (this.detail.canEditForm) {
        let editFormData = this.$refs.detail.getEditFormData()
        postData.formData = editFormData
      }
      this.btnApplyLoading = true
      // console.log('postData',postData,APIURL)
      // return 
      this.$api[APIURL](postData).then((res) => {
        if(res.code === 0){
          this.$refs.detail.fetchData()
        }
      }).finally(()=>{
        this.btnApplyLoading = false
      })
    },
    // 重置表单
    // resetForm() {
    //   this.$refs.processDetailForm.resetForm();
    // },
    // // 发起审批
    // submitForm() {
    //   const formData = this.$refs.processDetailForm.getFormData();
    //   const form = this.$refs.processDetailForm.getForm();
    //   const processUser = this.$refs.processDetailForm.getProcessUser();
    //   const strUserInfo = sessionStorage.getItem("userInfo");
    //   this.btnLoading = true;
    //   const postData = {
    //     processDefinitionId: form.processDefinitionId,
    //     formData,
    //     processUsers: processUser,
    //     startUserInfo: JSON.parse(strUserInfo),
    //   }
    //   // console.log("postData", postData);
    //   // return false;
    //   this.$refs.processDetailForm.validate((valid) => {
    //     if (valid) {
    //       this.$api.workflowStart(postData).then((res) => {
    //         // console.log("startProcess", res);
    //         if (res.code === 0) {
    //           this.$message.success("提交成功");
    //           this.$router.push({
    //             name: "approvalMyList",
    //           });
    //         }else if(res.message){
    //           this.$message.error(res.message);
    //         }
    //         this.btnLoading = false;
    //       }).catch(err=>{
    //         this.btnLoading = false;
    //       });
    //     } else {
    //       this.$message.warning("请完善表单");
    //       this.btnLoading = false;
    //     }
    //   });
    // },
  }
}
</script>
<style scoped lang="scss" src="./mixins/detailLayout.scss"></style>